import itemTypes from 'item_types.json';
import camelCase from 'lodash/camelCase';

const slugs = Object.keys(itemTypes).reduce((acc, t) => {
  acc[camelCase(t)] = itemTypes[t].display_slug;
  return acc;
}, {});

export default slugs;
